import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private toggleSidebar = new Subject<boolean>(); // small screen
  private overlaySidebarToggle = new Subject<boolean>();
  private toggleNotiSidebar = new Subject<boolean>();


  // Observable
  toggleSidebar$ = this.toggleSidebar.asObservable();
  overlaySidebarToggle$ = this.overlaySidebarToggle.asObservable();
  toggleNotiSidebar$ = this.toggleNotiSidebar.asObservable();

  toggleSidebarSmallScreen(toggle: boolean) {
    this.toggleSidebar.next(toggle);
  }

  overlaySidebartoggle(toggle: boolean) {
    this.overlaySidebarToggle.next(toggle);
  }

  toggleNotificationSidebar(toggle: boolean) {
    this.toggleNotiSidebar.next(toggle);
  }
  checkVerticalScroll(): boolean {
    const tableBody = document.querySelector('.datatable-body') as HTMLElement;
    return !!tableBody && tableBody.scrollHeight > tableBody.clientHeight;
  }

  updateColumnWidths(columns: any[], hideSidebar, templateConfig) {
    const scrollbarWidth = this.checkVerticalScroll() ? 17 : 0;
    let windowWidth = templateConfig.layout.sidebar.collapsed ? window.innerWidth - 156 : window.innerWidth;
    windowWidth -= scrollbarWidth;

    columns = columns.map(col => ({
      ...col,
      computedWidth: windowWidth > 1200 && !hideSidebar ? Math.floor((windowWidth - 298) * col.width) : Math.max(Math.floor((windowWidth) * col.width), col.minWidth)
    }));
    return columns
  }

  updateColumnWidthsForModal(columns: any[], hideSidebar: boolean, templateConfig: any, modalSize: "sm" | "md" | "lg" | "xl") {
    const modalSizeWiseWidth = {
      ["sm"]: 300,
      ["md"]: 500,
      ["lg"]: 800,
      ["xl"]: 1140,
    };
    columns = columns.map(col => ({
      ...col,
      computedWidth:
        modalSizeWiseWidth[modalSize] > 1200 && !hideSidebar
          ? Math.floor((modalSizeWiseWidth[modalSize] - 298) * col.width)
          : Math.max(Math.floor(modalSizeWiseWidth[modalSize] * col.width), col.minWidth)
    }));
    return columns;
  }
}
